import React, { Fragment } from "react";
import PropTypes from "prop-types";
import "./style.scss";

const BookedTicketItems = ({ ticket }) => {

    return (
        <>
            {ticket?.items?.length > 0 && ticket.items.map((item) => {
                const priceElements = [];

                if (item.quantity > 0) {
                    const { quantity } = item;
                    const hasRRP = item.rrp_pricing_cents && item.rrp_pricing_cents > 0;
                    const originalPriceCents = hasRRP ? item.rrp_pricing_cents : item.price_cents;
                    const originalPriceTotal = (originalPriceCents / 100) * quantity;
                    const hasPromo = item.promo_discount_cents && item.promo_discount_cents > 0;
                    const unitPromoDiscountCents = hasPromo
                        ? item.promo_discount_cents / item.quantity
                        : 0;

                    const priceAfterPromoCents = item.price_cents - unitPromoDiscountCents;
                    const pricePaidTotal = (priceAfterPromoCents / 100) * quantity;
                    
                    priceElements.push(
                        <span key={`${item.id}-original`} className="booked-ticket-items__price booked-ticket-items__price--rrp">
                            ${originalPriceTotal.toFixed(2)}
                        </span>
                    );
                    priceElements.push(
                        <span
                            key={`${item.id}-paid`}
                            className={`booked-ticket-items__price ${
                                hasPromo ? "booked-ticket-items__price--promo-price" : "booked-ticket-items__price--paid"
                            }`}
                        >
                            ${pricePaidTotal.toFixed(2)}
                        </span>
                    );
                }
                return (
                    <Fragment key={item.id}>
                        {item.quantity > 0 ? (
                            <div className="booked-ticket-items">
                                <div className="booked-ticket-items__item">
                                    <span className="booked-ticket-items__item-name">
                                        {item.quantity} x {item.name}
                                    </span>
                                    {priceElements.map((element, index) =>
                                        React.cloneElement(element, {
                                            className: `${element.props.className} ${index === 0 ? "booked-ticket-items__price--savings" : ""}`
                                        })
                                    )}
                                </div>
                            </div>
                        ) : null}
                    </Fragment>
                );
            })}
        </>
    );
};

BookedTicketItems.propTypes = {
    ticket: PropTypes.shape({
        items: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
                description: PropTypes.string.isRequired,
                quantity: PropTypes.number.isRequired,
                price_cents: PropTypes.number.isRequired,
                promo_discount_cents: PropTypes.number,
                rrp_pricing_cents: PropTypes.number,
            }),
        ).isRequired,
    }),
};

export default BookedTicketItems;
